import HeadDirection from './HeadDirection'
import { AnimationComponentProps as Props } from './phaseAnimation'

export default function HeadRight(props: Props) {
  return <HeadDirection direction="right" {...props} />
}
